module.exports = __webpack_public_path__ + "static/media/logo6.9992ede1.png";